import styled from 'styled-components'

export const ContactDetailsWrapper = styled.div`
  input {
    padding: 10px;
  }
  .row {
    margin-top: 20px;
  }
`
